import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, Alert, CardFooter } from 'reactstrap';
import OSelect from '../../../../Components/OElements/OSelect';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import {
    cleanDataGuide,
    restartRegisterGuide,
} from '../../../../slices/guide/reducer';
import {
    getRegisterGuide,
    deleteFile,
    registerGuide,
    getBeachCleaningList,
    getBeachCleaningData,
    getWarehouseList,
} from '../../../../slices/thunks';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import GuideDetailsRegisterList from '../GuideRegister/GuideDetailsRegisterList';
import { residue_config } from '../../../../config';
import { getFinalDestinationList, getResidueTypeList } from '../../../../helpers/residue/backend_helper';
import { getTransferCategoryList, getTransferList } from '../../../../helpers/transfer/backend_helper';
import { getEstablishmentList, getManagementTeamList } from '../../../../helpers/establishment/backend_helper';
import useFolderPathCreator from '../../../../helpers/utils/folder_path_creator';
import useFileType from '../../../../Components/Hooks/useFileTypeHooks';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import { useLoading } from '../../../../Context/LoadingContext';
import 'dayjs/locale/es-mx';
import useUnitMeasurement from '../../../../Components/Hooks/useUnitMeasurement';
import useUploadFiles from '../../../../Components/Hooks/useUploadFiles';
import usePathFolder from '../../../../Components/Hooks/usePathFolder';
import useEstablishmentAssignationUser from '../../../../Components/Hooks/useEstablishmentAssignationUser';
import { generateBeachCleaningReportPDF } from '../../../BeachCleaning/Reports/BeachCleaningReport';
import { cleanDataBeachCleaning } from '../../../../slices/beachCleaning/reducer';
import useLogoLoader from '../../../../Components/Hooks/useLogoLoaderHooks';
import dayjs from 'dayjs';

const GuideForm = (props) => {
    const {
        isEdit = false,
        handleToggleModal,
        handleChangeTitleForm = null,
        isOpen,
        activeTab,
        toggleTab,
        idResidueType = null,
        allowEstablishmentSelection = true,
        requireGuideDetailRegisterList = false,
        originEstablishmentId = null,
        nameOperation = null,
        dataThunk = null,
        thunk = null,
        establishmentListSelect = null,
        reducerState = null,
        reducerReset = null,
    } = props;

    const { idGuide } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { logoSrc } = useLogoLoader('login');
    const [loadedForm, setLoadedForm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const { openLoading, closeLoading } = useLoading();
    const [establishmentActive, setEstablishmentActive] = useState(null); 

    const {
        establishments,
        establishmentsListSelect,
		user
    } = useEstablishmentAssignationUser();

    const { dataUnitMeasurement } = useUnitMeasurement('KG');

    const selectorGuide = createSelector(
        state => state.Guides,
        guide => ({
            registerDisabled: guide.registerDisabled,
            dataGuide: guide.dataGuide,
            isAdding: guide.isAdding,
            isAdded: guide.isAdded,
            isUpdating: guide.isUpdating,
            isUpdated: guide.isUpdated,
            isLoadingList: guide.isLoadingList,
            itemGuide: guide.itemGuide,
            error: guide.error,
        })
    );
    const {
        registerDisabled,
        dataGuide,
        isAdding,
        isAdded,
        isUpdating,
        isUpdated,
        isLoadingList,
        itemGuide
        // requireCloseModal,
    } = useSelector(selectorGuide);


    const { file_type } = useFileType('GD');
    const [guideRegisterData, setGuideRegisterData] = useState(null);
    const [guideDetailsList, setGuideDetailsList] = useState([]);
    const [guideDate, setGuideDate] = useState(null);
    const [selectedEstablishmentItem, setSelectedEstablishmentItem] = useState(null);
    const [disableResidueType, setDisableResidueType] = useState(false);

    function handleEstablishmentSelected(establishment) {
        setSelectedEstablishmentItem(establishment);
    }

    function handleDeleteDocumentGuide(document_id) {
        if (!isEdit) {
            dispatch(deleteFile(document_id))
        }
    }

    const {
        uploadFiles,
    } = useUploadFiles();

    const handleUpdateReportBeachCleaning = async (beachCleaningList) => {
        // Generate updated report residue collected
        await Promise.all(beachCleaningList.map( async (beachCleaningRelated) => {

            const beachCleaningData = await dispatch(
                getBeachCleaningData(beachCleaningRelated['_id'])
            ).unwrap();
            
            // Generate report PDF with data
            const reportPDF = await generateBeachCleaningReportPDF(
                dispatch,
                logoSrc,
                beachCleaningData,
                beachCleaningData['photographic_records']
            )

            // Make file path on file manager
            const pathReport = usePathFolder(
                (
                    beachCleaningData?.sector?.establishment?.code_siep +
                    ' - ' +
                    beachCleaningData?.sector?.establishment?.name
                ) || '',
                'Limpiezas',
                beachCleaningData?.sector?.name || '',
                (
                    beachCleaningData.date
                        ? dayjs(beachCleaningData.date).format('DD-MM-YYYY')
                        : ''
                )
            );

            const dataUploadedFiles = await uploadFiles(
                pathReport,
                {
                    establishment_id: beachCleaningData?.sector?.establishment?._id
                },
                [
                    {
                        file_type_id: file_type?._id,
                        file: reportPDF
                    }
                ]
            );
        }))
    }

    const validation = useFormik({
        // enableReinitialize: use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            guide_id: '',
            document_id: '',
            guide_number: '',
            guide_date: '',
            guide_document: '',
            establishment_id: '',
            residue_type_id: '',
            destiny_type_id: '',
            warehouse_id: '',
            final_destination_id: '',
            transfer_category_id: '',
            patente_id: '',
            matricula_id: '',
            responsible_id: ''
        },
        validationSchema: Yup.object({
            guide_number: Yup.string().required('Campo requerido'),
            guide_date: Yup.string().required('Campo requerido'),
            guide_document: Yup.mixed()
                .when('guide_id', (guide_id) => {
                    if (guide_id == '') {
                        return Yup.mixed()
                            .test('documentUploaded', 'El documento de guía de despacho es requerido', value => {
                                return value ? true : false;
                            })
                            .test('documentFormat', 'Solo puede subir extensiones .pdf', value => {
                                if (value) {
                                    const supportedFormats = ['pdf'];
                                    return supportedFormats.includes(value.name.split('.').pop());
                                }
                                return true;
                            })
                            .test('documentSize', 'El archivo no puede superar el tamaño máximo de 10MB', value => {
                                if (value) {
                                    return value.size <= 10485760;
                                }
                                return true;
                            })
                    }
                }),
            establishment_id: Yup.string().required('Campo requerido'),
            residue_type_id: Yup.string().required('Campo requerido'),
            destiny_type_id: Yup.string().required('Campo requerido'),
            warehouse_id: Yup.string()
                .when('destiny_type_id', (destiny_type_id) => {
                    if (destiny_type_id == 1) {
                        return Yup.string().required('Campo requerido')
                    }
                }),
            final_destination_id: Yup.string()
                .when('destiny_type_id', (destiny_type_id) => {
                    if (destiny_type_id == 2) {
                        return Yup.string().required('Campo requerido')
                    }
                }),
            transfer_category_id: Yup.string().required('Campo requerido'),
            patente_id: Yup.string().required('Campo requerido'),
            matricula_id: Yup.string()
                .when('transfer_category_id', (transfer_category_id) => {
                    if ('660c0ded84e981c2bdf65d0d' == transfer_category_id) {
                        return Yup.string().required('Campo requerido')
                    }
                }),
            responsible_id: Yup.string().required('Campo requerido')
        }),
        onSubmit: async (values) => {
            setIsLoading(true);
            openLoading();

            let localFilesToUpload = []
            localFilesToUpload.push({
                file_type_id: file_type?._id,
                file: values.guide_document
            });

            const dataUploadedFiles = await uploadFiles(
                pathGD,
                {
                    'establishment_id': selectedEstablishmentItem?._id
                },
                localFilesToUpload
            );

            const registerGuideData = {
                ...(idGuide && { id: idGuide }),
                guide_date: values.guide_date,
                guide_number: values.guide_number,
                establishment_id: values.establishment_id,
                responsible_id: values.responsible_id || '',
                residue_type_id: values.residue_type_id,
                destiny_type_id: values.destiny_type_id,
                warehouse_id: values.warehouse_id &&
                    values.destiny_type_id == 1
                    ? values.warehouse_id : '',
                final_destination_id: values.final_destination_id &&
                    values.destiny_type_id == 2
                    ? values.final_destination_id : '',
                transfer_category_id: values.transfer_category_id,
                patente_id: values.patente_id,
                matricula_id: values.matricula_id,
                document_id: (
                    idGuide
                        ? values.document_id : (
                            values.document_id
                                ? document_id : dataUploadedFiles.files[0] || null
                        )
                ),
                observation: '',
                guide_details: guideDetailsList
            };

            if (thunk != null) {
                try {
                    if (
                        !dataUploadedFiles.files[0] &&
                        !idGuide
                    ){
                        throw new Error('Error: No existe id documento.');
                    }
                    const sendDataThunk = { ...dataThunk, ...{ data_guide: registerGuideData } }
                    const responseThunk = await dispatch(thunk(sendDataThunk)).unwrap();

                    const beachCleaningsRelatedGuide = await dispatch(
                        getBeachCleaningList({
                            guide_ids: [responseRegisterGuide['guide_id']]
                                .map(item => item)
                                .join()
                        })
                    ).unwrap();
                    
                    // Update reports beach cleaning
                    await handleUpdateReportBeachCleaning(beachCleaningsRelatedGuide);
                } catch (error) {
                    closeLoading();
                    console.error('Error al registrar guía:', error);
                    if (dataUploadedFiles[0] && !idGuide) {
                        handleDeleteDocumentGuide(dataUploadedFiles[0]);
                    }
                    setIsLoading(false);
                }
            } else {
                try {
                    if (
                        !dataUploadedFiles.files[0] &&
                        !idGuide
                    ) {
                        throw new Error('Error: No existe id documento.');
                    }
                    const responseRegisterGuide = await dispatch(registerGuide(registerGuideData)).unwrap();

                    const beachCleaningsRelatedGuide = await dispatch(
                        getBeachCleaningList({
                            guide_ids: [responseRegisterGuide['_id']]
                                .map(item => item)
                                .join()
                        })
                    ).unwrap();
                    
                    // Update reports beach cleaning
                    await handleUpdateReportBeachCleaning(beachCleaningsRelatedGuide);
                } catch (error) {
                    closeLoading();
                    console.error('Error al registrar guía:', error);
                    if (dataUploadedFiles[0] && !idGuide) {
                        handleDeleteDocumentGuide(dataUploadedFiles[0]);
                    }
                }
                setIsLoading(false);
            }
        }
    });

   

    const pathGD = usePathFolder(
        selectedEstablishmentItem?.name,
        'Medio Ambiente',
        'Residuo',
        validation.values.guide_number
    );

    useEffect(() => {
        if (handleChangeTitleForm != null) {
            handleChangeTitleForm((
                nameOperation
                    ? nameOperation
                    : (
                        idGuide
                            ? 'Editar Guía'
                            : 'Registrar Guía'
                    )
            ))
        }
        if (idGuide) {
            dispatch(getRegisterGuide(idGuide))
        }

        if(!idGuide){
            validation.setFieldValue("guide_date",  new Date());
        }
        
        return () => {
            dispatch(cleanDataGuide());
        }
    }, []);

    useEffect(() => {
        if (!idGuide) {
            setGuideDetailsList([]);
        }
    }, [idGuide]);

    useEffect(() => {
        if (dataGuide) {
            setGuideRegisterData(dataGuide);
            setLoadedForm(true);
            validation.setFieldValue("guide_id", idGuide || '');
            validation.setFieldValue("guide_date", new Date(dataGuide.guide_date) || '');
            validation.setFieldValue("guide_number", dataGuide.guide_number || '');
        }
    }, [dataGuide]);

    useEffect(() => {
        if (idGuide) {
            if (loadedForm && !guideRegisterData) {
                navigate('/404');
            }
            if (guideRegisterData) {
                setGuideDetailsList(guideRegisterData.guide_details);
            }
        }
    }, [guideRegisterData, itemGuide]);

    useEffect(() => {
        setDisableResidueType(!!guideDetailsList.length);
    }, [guideDetailsList])

    useEffect(() => {
        if (isAdded && !isLoading) {
            toast.info('Será redireccionado al listado de guías registradas.', { autoClose: 3000 });
            setTimeout(() => {
                navigate('/residue/guides');
                closeLoading();
                dispatch(restartRegisterGuide());
            }, 3500);
        }
    }, [
        isAdded,
        isLoading
    ]);

    useEffect(() => {
        if (reducerState) {
            if (reducerReset != null) {
                dispatch(reducerReset());
            }
            setTimeout(() => {
                closeLoading();
                dispatch(restartRegisterGuide());
            }, 3500);
        }
    }, [reducerState]);

    useEffect(() => {
        if (user) {
            setEstablishmentActive(user?.establishment_active_id);
        }
    }, [user]);

    return (
        <React.Fragment>
            {/* Banner de Migración al Nuevo Generador */}
            <Alert color='warning' className='mb-4 border-warning'>
                <div className='d-flex align-items-start gap-3'>
                    <i className='ri-information-line fs-20 mt-1'></i>
                    <div className='flex-grow-1'>
                        <h6 className='alert-heading mb-2'>
                            <strong>Nuevo Generador de Guías Disponible</strong>
                        </h6>
                        <p className='mb-2'>
                            Este formulario ha sido migrado al nuevo generador unificado de guías 
                            con soporte para <strong>DTE automático</strong>. Ahora puede generar 
                            guías de despacho sin necesidad de subirlas manualmente.
                        </p>
                        <Button
                            color='primary'
                            size='sm'
                            onClick={() =>
                                navigate('/warehouse/guide/register?category=residuos')
                            }
                        >
                            <i className='ri-arrow-right-line me-1'></i>
                            Ir al Nuevo Generador
                        </Button>
                    </div>
                </div>
            </Alert>
            
            <Form className='tablelist-form' onSubmit={e => {
                e.preventDefault();
                return false;
            }}>
                {(idGuide && guideRegisterData || !idGuide && !guideRegisterData ?
                    <div>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId='1'>
                                <Card className="mt-4 border">
                                    <CardBody className="p-4">
                                        <div className="pb-2">
                                            <h5 className="">Información de origen</h5>
                                            {/* <p className="text-muted">Selecciona los datos requeridos correspondientes al origen de la guía.</p> */}
                                        </div>
                                        <Row className='g-3'>
                                            <Col lg={4}>
                                                <OSelect
                                                    key={
                                                        (
                                                            originEstablishmentId
                                                                ? originEstablishmentId
                                                                : dataGuide?.establishment_id
                                                        ) || ''
                                                    }
                                                    label='Establecimiento'
                                                    id='establishment_id'
                                                    name='establishment_id'
                                                    value={
                                                        (
                                                            originEstablishmentId
                                                                ? originEstablishmentId
                                                                : dataGuide?.establishment_id
                                                        ) || ''
                                                    }
                                                    onSelect={handleEstablishmentSelected}
                                                    requestApi={() => getEstablishmentList({})}
                                                    itemsSelect={
                                                        establishmentListSelect
                                                    }
                                                    disabled={(
                                                        allowEstablishmentSelection
                                                            ? false : true
                                                    )}
                                                    validation={validation}
                                                />
                                            </Col>
                                            <Col sm={4}>
                                                <DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
                                                    <DatePickerInput
                                                        label='Fecha'
                                                        id='guide_date'
                                                        name='guide_date'
                                                        placeholder="Seleccione una fecha"
                                                        value={validation.values.guide_date}
                                                        onChange={(date) => {
                                                            validation.setFieldValue("guide_date", date);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        valueFormat='DD-MM-YYYY'
                                                        maxDate={new Date()}
                                                        error={
                                                            validation.touched['guide_date'] &&
                                                                validation.errors['guide_date']
                                                                ? validation.errors['guide_date'] : ''
                                                        }
                                                        clearable={true}
                                                    />
                                                </DatesProvider>
                                            </Col>
                                            <Col lg={4}>
                                                <OSelect
                                                    key={dataGuide?.responsible_id || null}
                                                    label='Responsable'
                                                    id='responsible_id'
                                                    name='responsible_id'
                                                    value={dataGuide?.responsible_id || null}
                                                    requestApi={() => getManagementTeamList()}
                                                    handleLabelOptions={(item) => `${item?.person?.full_name || 'sin responsable'}`}
                                                    disabled={false}
                                                    validation={validation}
                                                />
                                            </Col>
                                            {
                                                (!residue_config.REACT_APP_DTE_ENABLED ?
                                                    <React.Fragment>
                                                        <Col lg={4}>
                                                            <Label for='guide_number' className='form-label'>
                                                                N° de guía de despacho
                                                            </Label>
                                                            <Input
                                                                name='guide_number'
                                                                id='guide_number'
                                                                className='form-control'
                                                                placeholder='Ingrese un número'
                                                                type='number'
                                                                validate={{ required: { value: true } }}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                value={validation.values.guide_number}
                                                                invalid={
                                                                    validation.touched.guide_number &&
                                                                        validation.errors.guide_number
                                                                        ? true : false
                                                                }
                                                            />
                                                            {
                                                                validation.touched.guide_number &&
                                                                    validation.errors.guide_number ? (
                                                                    <FormFeedback type='invalid'>
                                                                        {validation.errors.guide_number}
                                                                    </FormFeedback>
                                                                ) : null
                                                            }
                                                        </Col>
                                                        <Col lg={8}>
                                                            <Label for="guide_document">
                                                                Guía de despacho
                                                            </Label>
                                                            <Input
                                                                id="guide_document"
                                                                name="guide_document"
                                                                type="file"
                                                                accept='.pdf'
                                                                onChange={(e) => {
                                                                    const file = e.currentTarget.files[0];
                                                                    validation.setFieldValue("guide_document", file || '');
                                                                }}
                                                                onBlur={validation.handleBlur}
                                                                invalid={
                                                                    validation.touched.guide_document &&
                                                                        validation.errors.guide_document ?
                                                                        true : false
                                                                }
                                                            />
                                                            {
                                                                validation.touched.guide_document &&
                                                                    validation.errors.guide_document ? (
                                                                    <FormFeedback type='invalid'>
                                                                        {validation.errors.guide_document}
                                                                    </FormFeedback>
                                                                ) : null
                                                            }
                                                        </Col>
                                                    </React.Fragment>
                                                    :
                                                    null
                                                )
                                            }
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Row>
                                    <Col lg={6} className='mb-4'>
                                        <Card className="border h-100">
                                            <CardBody className="p-4 pb-0">
                                                <div className="pb-2">
                                                    <h5 className="">Información de destino</h5>
                                                    {/* <p className="text-muted">Selecciona los datos requeridos correspondientes al destino de los residuos a registrar.</p> */}
                                                </div>
                                                <Row className='g-3'>
                                                    <Col lg={6}>
                                                        <OSelect
                                                            key={dataGuide?.residue_type_id || ''}
                                                            label='Tipo de Residuo'
                                                            id='residue_type_id'
                                                            name='residue_type_id'
                                                            value={
                                                                (
                                                                    idResidueType
                                                                        ? idResidueType :
                                                                        dataGuide?.residue_type_id
                                                                ) || ''
                                                            }
                                                            requestApi={() => getResidueTypeList({})}
                                                            disabled={(
                                                                idResidueType || disableResidueType
                                                                    ? true : false
                                                            )}
                                                            validation={validation}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <OSelect
                                                            key={dataGuide?.destiny_type_id || ''}
                                                            label='Tipo de Destino'
                                                            id='destiny_type_id'
                                                            name='destiny_type_id'
                                                            value={dataGuide?.destiny_type_id || ''}
                                                            itemsSelect={[
                                                                { value: 1, label: 'Bodega Transitoria', item: { _id: 1, name: 'Bodega Transitoria' } },
                                                                { value: 2, label: 'Disposición Final', item: { _id: 2, name: 'Disposición Final' } },
                                                            ]}
                                                            disabled={false}
                                                            validation={validation}
                                                        />
                                                    </Col>
                                                    <Col lg={12}>
                                                        {
                                                            (validation.values['destiny_type_id'] ?
                                                                (validation.values['destiny_type_id'] == 1 ?
                                                                    <OSelect
                                                                        key={1}
                                                                        label={`Destino: Bodega Transitoria`}
                                                                        id='warehouse_id'
                                                                        name='warehouse_id'
                                                                        value={dataGuide?.warehouse_id || ''}
                                                                        requestApi={() => getWarehouseList({})}
                                                                        // handleLabelOptions={(item) => item.establishment.name}
                                                                        disabled={(
                                                                            validation.values['destiny_type_id'] != null
                                                                                ? false : true
                                                                        )}
                                                                        validation={validation}
                                                                    />
                                                                    :
                                                                    <OSelect
                                                                        key={2}
                                                                        label={`Destino: Destino Final`}
                                                                        id='final_destination'
                                                                        name='final_destination_id'
                                                                        value={dataGuide?.final_destination_id || ''}
                                                                        requestApi={() => getFinalDestinationList()}
                                                                        disabled={(
                                                                            validation.values['destiny_type_id'] != null
                                                                                ? false : true
                                                                        )}
                                                                        validation={validation}
                                                                    />
                                                                )
                                                                :
                                                                <div>
                                                                    <label htmlFor='device-field' className='form-label'>
                                                                        Destino
                                                                    </label>
                                                                    <Alert color="primary" className='m-0 py-2'>
                                                                        Debe seleccionar un <b className='fw-bold'>tipo de destino</b> para definir el <b className='fw-bold'>destino</b> de los residuos.
                                                                    </Alert>
                                                                </div>
                                                            )
                                                        }
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col lg={6} className='mb-4'>
                                        <Card className="border h-100">
                                            <CardBody className="p-4 pb-0">
                                                <div className="pb-2">
                                                    <h5 className="">Información de transporte</h5>
                                                    {/* <p className="text-muted">Selecciona los datos requeridos correspondientes al transporte de los residuos a registrar.</p> */}
                                                </div>
                                                <Row className='g-3'>
                                                    <Col lg={12}>
                                                        <OSelect
                                                            key={dataGuide?.transfer_category_id || ''}
                                                            label='Medio de transporte'
                                                            id='transfer_category_id'
                                                            name='transfer_category_id'
                                                            value={dataGuide?.transfer_category_id || ''}
                                                            requestApi={() => getTransferCategoryList({})}
                                                            disabled={false}
                                                            validation={validation}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <OSelect
                                                            key={`${dataGuide?.patente_id}${validation.values['final_destination_id']}` || ''}
                                                            label='Patente'
                                                            id='patente_id'
                                                            name='patente_id'
                                                            value={dataGuide?.patente_id || ''}
                                                            handleLabelOptions={(item) => `${item.patent} | ${item.transfer_company.name}`}
                                                            requestApi={() => getTransferList({
                                                                transfer_category_id: residue_config.REACT_APP_TRANSFER_CATEGORY_GROUND,
                                                                final_destination_id: validation.values['final_destination_id']
                                                            })}
                                                            disabled={false}
                                                            validation={validation}
                                                        />
                                                    </Col>
                                                    <Col lg={6}>
                                                        <OSelect
                                                            key={`${dataGuide?.matricula_id}_${validation.values['final_destination_id']}` || ''}
                                                            label='Matrícula'
                                                            id='matricula_id'
                                                            name='matricula_id'
                                                            value={dataGuide?.matricula_id || ''}
                                                            handleLabelOptions={(item) => `${item.patent} | ${item.transfer_company.name}`}
                                                            requestApi={() => getTransferList({
                                                                transfer_category_id: residue_config.REACT_APP_TRANSFER_CATEGORY_MARITIME,
                                                                final_destination_id: validation.values['final_destination_id']
                                                            })}
                                                            disabled={(
                                                                validation.values['transfer_category_id'] != null &&
                                                                    validation.values['transfer_category_id'] ==
                                                                    residue_config.REACT_APP_TRANSFER_CATEGORY_MARITIME
                                                                    ? false : true
                                                            )}
                                                            validation={validation}
                                                        />
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            {(
                                requireGuideDetailRegisterList
                                    ? <Row>
                                        <Col lg={12}>
                                            <GuideDetailsRegisterList
                                                unitMeasurementResidueCollected={dataUnitMeasurement}
                                                finalDestinationSelected={(
                                                    validation.values['final_destination_id'] &&
                                                        validation.values['destiny_type_id'] == 2
                                                        ? validation.values['final_destination_id']
                                                        : null
                                                )}
                                                residueType={validation.values['residue_type_id']}
                                                guideDetailsList={guideDetailsList}
                                                handlerSetGuideDetailsList={setGuideDetailsList}
                                            />
                                        </Col>
                                    </Row>
                                    : null
                            )}
                        </TabContent>
                        <div className='hstack gap-2 justify-content-end'>
                            <Button type='button' onClick={() => { handleToggleModal(); }} className='btn-danger btn-label'>
                                <i className="ri-close-line label-icon"></i>
                                Cancelar
                            </Button>
                            <button
                                type='button'
                                className='btn btn-label btn-primary'
                                id='add-btn'
                                disabled={(
                                    isAdding ||
                                    isUpdating ||
                                    reducerState ||
                                    registerDisabled ||
                                    isLoading
                                )}
                                onClick={() => {
                                    if (Object.keys(validation.errors).length != 0) {
                                        toast.error(
                                            'Se han detectado errores en los datos del formulario. Por favor verifique los datos nuevamente.',
                                            { autoClose: 4000 }
                                        );
                                    }
                                    validation.handleSubmit();
                                }}
                            >
                                {
                                    (
                                        isAdding ||
                                        isUpdating ||
                                        reducerState ||
                                        registerDisabled ||
                                        isLoading)
                                        ? <i className='label-icon'><Spinner size='sm' /></i>
                                        : <i className="ri-save-3-line label-icon"></i>

                                }
                                {
                                    nameOperation
                                        ? nameOperation
                                        : (
                                            idGuide
                                                ? 'Editar Guía'
                                                : 'Registrar Guía'
                                        )

                                }
                            </button>
                        </div>
                    </div>
                    :
                    null)}
            </Form>
        </React.Fragment>
    );
};

export default GuideForm;
